export const V2Type = {
  Number: 'number',
  Artifact: 'artifact',
  Npi: 'npi',
  Reference: 'reference',
};

export const STATUS_CONFIG = {
  pending_verification: {
    label: 'Pending Verification',
    color: '#307F92',
  },
  /**
   * @deprecated Temporary status: backend should return 'pending_verification' instead of 'pending'
   */
  pending: {
    label: 'Pending Verification',
    color: '#307F92',
  },
  verified: { label: 'Verified', color: '#28a745' },
  invalid: { label: 'Invalid', color: '#d32f2f' },
  expired: { label: 'Expired', color: '#d32f2f' },
};

export const getStatusConfig = (status) =>
  STATUS_CONFIG[status] || { label: '-', color: '#6c757d' };

/**
 * Temporary fallback: derive authorization status from credentials until BE updates.
 * If all required credentials are verified, the authorization status is treated as verified.
 */
export const getDerivedStatus = (status, credentials = []) => {
  const requiredCreds = credentials.filter((c) => c?.is_required);
  if (requiredCreds.length > 0 && requiredCreds.every((c) => c.status === 'verified')) {
    return 'verified';
  }
  return status;
};
